import {
    main,
    container
} from "../../material-kit-pro-react.jsx";

import imagesStyles from "../imagesStyles.jsx";

const sectionsPageStyle = {
    ...imagesStyles,
    main: {
        ...main
    },
    container: {
        ...container,
        zIndex: 1
    },
    left: {
        float: "left!important",
        display: "block"
    },
    right: {
        padding: "15px 0",
        margin: "0",
        float: "right"
    },
    img: {
        width: "20%",
        marginRight: "5%",
        marginBottom: "5%",
        float: "left"
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0"
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto"
    },
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block"
    },
    linksVertical: {
        "& li": {
            display: "block !important",
            marginLeft: "-5px",
            marginRight: "-5px",
            "& a": {
                padding: "5px !important"
            }
        }
    },
    socialButtons: {
        "& li": {
            display: "inline-block"
        }
    },
    socialFeed: {
        "& p": {
            display: "table-cell",
            verticalAlign: "top",
            overflow: "hidden",
            paddingBottom: "10px",
            maxWidth: 300
        },
        "& i": {
            fontSize: "20px",
            display: "table-cell",
            paddingRight: "10px"
        }
    }
};

export default sectionsPageStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/sectionsPageStyle.jsx